import { get as getCookie } from 'js/lib/cookie';

import localStorageEx from 'bundles/common/utils/localStorageEx';
import { LOGGED_OUT_ONBOARDING_LOCAL_STORAGE_KEY } from 'bundles/onboarding-common/constants';
import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import type { LearnerObjectMetadata } from 'bundles/onboarding-common/types';
import type { LocalStorageOnboardingDataType } from 'bundles/onboarding-common/types/LocalStorage';

const getLocalStorageOnboardingData = (): LocalStorageOnboardingDataType | undefined => {
  const localStorageData = localStorageEx.getItem<Record<string, LocalStorageOnboardingDataType>>(
    LOGGED_OUT_ONBOARDING_LOCAL_STORAGE_KEY,
    JSON.parse,
    {}
  );
  const sessionId = getCookie('__204u');

  if (localStorageData && sessionId && localStorageData[sessionId]) {
    return localStorageData[sessionId];
  }

  return undefined;
};

const updateLocalStorageOnboardingData = (data: LocalStorageOnboardingDataType) => {
  const localStorageData = localStorageEx.getItem<Record<string, LocalStorageOnboardingDataType>>(
    LOGGED_OUT_ONBOARDING_LOCAL_STORAGE_KEY,
    JSON.parse,
    {}
  );
  const sessionId = getCookie('__204u');

  if (sessionId) {
    const previousData = localStorageData[sessionId];
    localStorageData[sessionId] = previousData ? { ...previousData, ...data } : data;
    localStorageEx.setItem(LOGGED_OUT_ONBOARDING_LOCAL_STORAGE_KEY, localStorageData, JSON.stringify);
  }
};

const clearLocalStorageOnboardingData = () => {
  localStorageEx.removeItem(LOGGED_OUT_ONBOARDING_LOCAL_STORAGE_KEY);
};

const formatLocalStorageMetadata = (
  localStorageData?: LocalStorageOnboardingDataType
): LearnerObjectMetadata | null => {
  const savedRoles =
    localStorageData?.[QUESTION_IDS.roleSelect]?.value || localStorageData?.[QUESTION_IDS.roleSelectAdvancer]?.value;
  const savedRoleNames = savedRoles?.map((role) => role.name);

  const savedSkills = localStorageData?.[QUESTION_IDS.skillSelect]?.value;
  const savedSkillNames = savedSkills?.map((skill) => skill.skillName);

  const savedLearningGoal = localStorageData?.[QUESTION_IDS.learningGoal]?.value;

  if (!savedLearningGoal || !savedRoleNames?.length) return null;

  const learnerObjectMetadata: LearnerObjectMetadata = {
    learningGoalType: savedLearningGoal,
    roles: savedRoleNames,
    skills: savedSkillNames,
  };

  return learnerObjectMetadata;
};

export {
  getLocalStorageOnboardingData,
  updateLocalStorageOnboardingData,
  clearLocalStorageOnboardingData,
  formatLocalStorageMetadata,
};
